module.exports = __webpack_public_path__ + "assets/img/3017.e6111015.svg";